import ErrorMessage from "controls/global/error-message";
import React, {
  ReactElement,
  useState,
} from "react";
import {
  Controller,
  useFormContext,
} from "react-hook-form";
import useFieldDisabler from "utils/custom-hooks/useFieldDisabler";
import TextInput from "./TextInput";
import { colors, fontSize, padding } from "theme/defaultStyle";

interface Props {
  label?: string | undefined;
  name: any;
  defaultValue?: any;
  type?: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<any>) => void;
  onBlur?: any;
  className?: any;
  inputProps?: any;
  InputProps?: any;
  actionButton?: ReactElement;
  placeholder?: string;
  multiline?: boolean;
  rows?: number;
  size?: "small" | "medium";
  style?: React.CSSProperties;
  errorClassName?: string;
  maxLength?: number;
  errorMaxLength?: number;
  errorMessageExceedLimit?: string;
  isRequired?: boolean;
  requiredMessage?: string;
  onErrorChange?: (hasError: boolean) => void;
  sx?: any;
  validateOnChange?: boolean;
  error?: boolean;
}

const TextInputField = (props: Props) => {
  const {
    defaultValue,
    name,
    onBlur,
    onChange,
    disabled,
    style,
    errorClassName,
    maxLength,
    errorMaxLength,
    errorMessageExceedLimit,
    isRequired = false,
    requiredMessage = "Required",
    onErrorChange,
    validateOnChange ,
    error,
    ...others
  } = props;

  const { control } = useFormContext();
  const [isErrorForMaxLength, setIsErrorForMaxLength] = useState<boolean>(false);
  const [isErrorForRequired, setIsErrorForRequired] = useState<boolean>(false);

  const handleOnChange =  (
    e: React.ChangeEvent<any>,
    onChangeFormHandler?: any,
  ) => {
    setIsErrorForRequired(false);

    const newValue = e.target.value;
    if (typeof errorMaxLength === 'number') {
      setIsErrorForMaxLength(newValue.length > errorMaxLength);
      const error = newValue.length > errorMaxLength;
      onErrorChange?.(error);
    }
    onChangeFormHandler && onChangeFormHandler(e);
    onChange && onChange(e);
  };

  const handleOnBlur = (e: React.ChangeEvent<any>, onBlurFormHandler: any) => {
    const newValue = e.target.value;
    if (isRequired) {
      setIsErrorForRequired(newValue?.trim().length === 0);
    }
    onBlurFormHandler();
    onBlur && onBlur(e);
  };
  const shouldFieldBeDisabled = useFieldDisabler(name);

  // console.log("isErrorForRequired:", isErrorForRequired);
  // console.log("isErrorForMaxLength:", isErrorForMaxLength);

  return (
    <>
      <Controller
        control={control}
        name={name}
        defaultValue={defaultValue}
        render={({ field: { name, value, onChange, onBlur, ref }, fieldState }) => {
          return (
            <>
              <TextInput
                onChange={(event: React.ChangeEvent<any>) => {
                  handleOnChange(event, onChange);
                }}
                disabled={disabled || shouldFieldBeDisabled}
                onBlur={(event: React.ChangeEvent<any>) => handleOnBlur(event, onBlur)}
                fieldRef={ref}
                size={others.size}
                {...{ value, name, maxLength, ...others }}
                hasError={isErrorForMaxLength || Boolean(fieldState.error) || error}
                style={others.sx || style}
              // inputProps={maxLength}
              />
              {props.actionButton}
            </>
          );
        }}
      />
      { validateOnChange && errorMaxLength  ? null :   <ErrorMessage
        name={props.name}
        style={style}
        className={errorClassName}
        errorMessageParent={errorMessageExceedLimit}
      /> }
      {isRequired && isErrorForRequired && (
        <div style={{ fontSize: fontSize.small, color: colors.red01, paddingLeft: padding.xsmall1 }}>{requiredMessage}</div>
      )}
      {!isErrorForRequired && isErrorForMaxLength && (
        <div style={{ fontSize: fontSize.small, color: colors.red01, paddingLeft: padding.xsmall1 }}>{errorMessageExceedLimit}</div>
      )}
    </>
  );
};

export default TextInputField;
